<template>
  <el-drawer :visible.sync="drawer" direction="ltr" size="70%" @closed="$emit('close')">
    <div slot="title" style="display: flex;justify-content: flex-end;margin-right: 40px;">
      <el-button @click="addContainer" type="primary">创建容器 </el-button>
      <el-button @click="getLogistics" type="primary">一键获取物流单号 </el-button>
    </div>
    <el-table :data="containerList" stripe style="width: 100%" :default-expand-all="true">
      <el-table-column label="容器名称" prop="deliveryTaskCode">
        <template slot-scope="props">
          <span> 容器--{{ props.row.deliveryTaskLogisticsDetailId }} </span>
        </template>
      </el-table-column>
      <el-table-column label="总重量" prop="containerWeight" width="100">
        <template slot-scope="props">
          <span> {{ props.row.containerWeight / 1000 }} KG </span>
        </template>
      </el-table-column>
      <el-table-column label="总数量" prop="containerWeight" width="100">
        <template slot-scope="props">
          <span> {{ props.row.skuNum }}件 </span>
        </template>
      </el-table-column>
      <el-table-column label="美金上限" prop="containerWeight" width="100">
        <template slot-scope="props">
          <span> {{ (!props.row.priceLimit || props.row.priceLimit == '-1') ? '无限制' : props.row.priceLimit + '美元'
            }}</span>
        </template>
      </el-table-column>
      <el-table-column label="重量上限" prop="containerWeight" width="100">
        <template slot-scope="props">
          <span> {{ (!props.row.weightLimit || props.row.weightLimit == '-1') ? '无限制' : props.row.weightLimit + 'KG' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="物流单号" prop="logisticsCode">
        <div slot-scope="props" style="display: flex">
          <el-input maxlength='450' v-model="props.row.newLogisticsCode" placeholder="手动设置物流单号"></el-input>
          <el-button type="primary" @click="setShipNumber(props.row)">修改</el-button>
        </div>
      </el-table-column>
      <el-table-column label="操作" prop="logisticsCode">
        <template slot-scope="props">
          <el-button type="primary" @click="printLogistics(props.row)">打印物流面单</el-button>
          <el-button type="primary" @click="openAddBoxDialog(props.row)">添加箱子</el-button>
          <el-popconfirm
            title="确认删除该容器吗？"
            @confirm="delBox(props.row)"
          >
            <el-button slot="reference" type="danger">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
      <!--        // 展开容器-->
      <el-table-column type="expand">
        <template slot-scope="props">
          <BoxList v-model="props.row.deliveryBoxList" :insidePackCode="props.row.insidePackCode"
            :deliveryTaskCode="props.row.deliveryTaskCode" :openBoxInfo="openBoxInfo" @refresh="getContainerDetail()"
            @openBoxInfo="setOpenBoxInfo" />
        </template>
      </el-table-column>
    </el-table>
    <AddContainerDialog :boxTemplates="boxTemplates" ref="AddContainerDialog" />
  </el-drawer>
</template>

<script>
import BoxList from "@/views/outOfStock/FBABagPackage/components/BoxList";
import AddContainerDialog from "@/views/outOfStock/FBABagPackage/components/AddContainerDialog";
import { getLogisticsInfoList, setContainerBoxInfo, setLogisticstInfo, getLogisticsNo, deleteLogisticsTask, getBox } from "@/apis/outStock";
export default {
  name: "containerList",
  components: {
    AddContainerDialog,
    BoxList,
  },
  inject: ["productSkuAll"],
  data() {
    return {
      deliveryTaskCode: "",
      drawer: false,
      containerList: [],
      openBoxInfo: '',
      boxTemplates: []
    };
  },
  mounted() {
    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplates = data
        console.log(this.boxTemplates)
      }
    })
    // 接收事件总线
    const that = this;
    that.$bus.$on("triggerRefreshFBA", () => {
      //刷新容器箱子信息
      console.log('1')
      that.getContainerDetail();
    });
  },
  watch: {
    drawer: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          console.log('2')
          this.getContainerDetail();
        }
      },
    },
    containerList: {
      deep: true,
      handler: function (newVal) {
        let list = [];
        // 展平
        if (!!newVal && !!newVal.length) {
          newVal.forEach((item) => {
            if (!!item.deliveryBoxList && !!item.deliveryBoxList.length) {
              item.deliveryBoxList.forEach((temp) => {
                if (!!temp.deliveryBoxDetailList && !!temp.deliveryBoxDetailList.length) {
                  temp.deliveryBoxDetailList.forEach((product) => {
                    list.push(product);
                  });
                }
              });
            }
          });
        }
        // 去重
        const obj = {};
        list.forEach((item) => {
          const nums = obj[item.shopProductSku];
          if (nums) {
            obj[item.shopProductSku] += item.nums;
          } else {
            obj[item.shopProductSku] = item.nums;
          }
        });
        //计算总重量
        newVal.forEach((item) => {
          let weight = 0,
            skuNum = 0;
          item.deliveryBoxList &&
            item.deliveryBoxList.forEach((temp) => {
              console.log("item.weight", item.weight);
              weight += parseFloat(temp.weight || 0);
              skuNum += parseFloat(temp.nums);
            });
          item.containerWeight = weight;
          this.$set(item, "skuNum", skuNum);
          console.log("item.skuNum", item.skuNum);
        });
        this.$emit("containerChange", obj);
      },
    },
  },
  methods: {
    setOpenBoxInfo(id) {
      this.openBoxInfo = id
    },
    open: function ({ deliveryTaskCode }) {
      if (deliveryTaskCode === "" || !deliveryTaskCode) {
        this.$message.error("请先扫描发货任务");
        return;
      }
      this.drawer = true;
      this.deliveryTaskCode = deliveryTaskCode;
    },
    clean: function () {
      this.deliveryTaskCode = "";
      this.drawer = false;
      this.containerList = [];
    },
    getLogistics() {
      this.$emit('getLogistics')
    },
    // 新增容器
    addContainer: function () {
      const that = this;
      setLogisticstInfo({
        deliveryTaskCode: that.deliveryTaskCode,
      }).then(({ code }) => {
        if (code === 0) {
          that.$message.success("创建成功");
          console.log('3')
          that.getContainerDetail();
        }
      });
    },
    // 删除容器
    delBox: function (row) {
      const that = this;
      const params = {
        insidePackCode: row.insidePackCode,
      };
      deleteLogisticsTask(params).then((res) => {
        console.log(res);
        const { code = -1 } = res;
        if (code === 0) {
          that.$message.success("删除成功");
          that.getContainerDetail();
        }
      });
    },
    // 打印物流面单
    printLogistics: function (c) {
      console.log(c);
      if (c.logisticsTagUrl) {
        window.open(c.logisticsTagUrl);
      } else {
        this.$message.warning("无物流信息");
      }
    },
    // 设置物流单号
    // 手填物流单号
    setShipNumber: function ({ deliveryTaskCode, deliveryTaskLogisticsDetailId, newLogisticsCode }) {
      const that = this;
      const params = {
        deliveryTaskCode,
        deliveryTaskLogisticsDetailId,
        logisticsCode: newLogisticsCode,
      };
      setLogisticstInfo(params).then(({ code, msg }) => {
        if (code === 0) {
          // 手动设置物流单号成功
          that.shipmentNumber = that.newShipmentNumber;
          that.$message.success("物流号更新成功！");
        } else {
          // 手动设置物流单号成功
          that.newShipmentNumber = that.shipmentNumber;
          that.$message.error("物流号更新失败！");
        }
        console.log('4')
        that.getContainerDetail();
      });
    },
    // 容器添加箱子相关
    openAddBoxDialog: function (c) {
      this.$refs["AddContainerDialog"].open(c);
    },
    getContainerDetail: function () {
      console.log('getContainerDetail')
      const params = {
        deliveryTaskCode: this.deliveryTaskCode,
      };
      getLogisticsInfoList(params).then((res) => {
        const { code, data = [] } = res;
        if (code === 0) {
          this.containerList = data.map((item) => {
            const { deliveryBoxList = [], logisticsCode = "" } = item;
            const containerWeight = deliveryBoxList.reduce((pre, item) => {
              const { weight } = item;
              return pre + weight;
            }, 0);
            return {
              ...item,
              newLogisticsCode: logisticsCode,
              containerWeight,
            };
          });
        }
      });
    },
  },
};
</script>

<style scoped></style>
